import global from './global';
import menu from './menu';
import user from './user';
import login from './login';

const store = {
  global,
  menu,
  user,
  login
};

export default store;
